import useReveal from '../../../shared/hooks/useReveal';

// Local SVG logos (primary source — no CDN dependency)
import quickbooksLogo from '../../../shared/assets/logos/integrations/quickbooks.svg';
import squareLogo from '../../../shared/assets/logos/integrations/square.svg';
import shopifyLogo from '../../../shared/assets/logos/integrations/shopify.svg';
import stripeLogo from '../../../shared/assets/logos/integrations/stripe.svg';
import airtableLogo from '../../../shared/assets/logos/integrations/airtable.svg';
import paypalLogo from '../../../shared/assets/logos/integrations/paypal.svg';
import gustoLogo from '../../../shared/assets/logos/integrations/gusto.svg';
import hubspotLogo from '../../../shared/assets/logos/integrations/hubspot.svg';
import xeroLogo from '../../../shared/assets/logos/integrations/xero.svg';
import zapierLogo from '../../../shared/assets/logos/integrations/zapier.svg';
import notionLogo from '../../../shared/assets/logos/integrations/notion.svg';
import googlesheetsLogo from '../../../shared/assets/logos/integrations/googlesheets.svg';

const integrations = [
  { name: 'QuickBooks', logo: quickbooksLogo },
  { name: 'Square', logo: squareLogo },
  { name: 'Shopify', logo: shopifyLogo },
  { name: 'Stripe', logo: stripeLogo },
  { name: 'Airtable', logo: airtableLogo },
  { name: 'PayPal', logo: paypalLogo },
  { name: 'Gusto', logo: gustoLogo },
  { name: 'HubSpot', logo: hubspotLogo },
  { name: 'Xero', logo: xeroLogo },
  { name: 'Zapier', logo: zapierLogo },
  { name: 'Notion', logo: notionLogo },
  { name: 'Google Sheets', logo: googlesheetsLogo },
];

const Integrations = () => {
  const [ref, visible] = useReveal({ threshold: 0.3 });

  return (
    <section ref={ref} className="py-16 md:py-20 bg-white border-t border-b border-zinc-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-10">
        <p className={`text-xs uppercase tracking-[0.25em] text-zinc-400 text-center reveal from-below ${visible ? 'visible' : ''}`}>
          Connects to the tools you already use
        </p>
      </div>
      <div className={`overflow-hidden transition-opacity duration-1000 ${visible ? 'opacity-100' : 'opacity-0'}`}
           style={{ transitionDelay: '0.2s' }}>
        <div className="flex animate-[tickerScroll_40s_linear_infinite] w-max items-center">
          {[...integrations, ...integrations].map((item, i) => (
            <div key={i} className="flex items-center gap-3 px-8">
              <img
                src={item.logo}
                alt={item.name}
                className="h-5 w-5 object-contain opacity-40 select-none pointer-events-none"
                draggable="false"
              />
              <span className="text-sm text-zinc-500 tracking-wide whitespace-nowrap">{item.name}</span>
              <span className="text-zinc-200 text-lg ml-5">·</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Integrations;
